import { render, staticRenderFns } from "./attStatus.vue?vue&type=template&id=958a67ce"
import script from "./attStatus.vue?vue&type=script&lang=js"
export * from "./attStatus.vue?vue&type=script&lang=js"
import style0 from "./attStatus.vue?vue&type=style&index=0&id=958a67ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports